import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../assets/theme";
import ProgressCircle from "./ProgressCircle";

const StatBox = ({ title, subtitle, icon, progress, increase }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box width="100%" m="0 30px">
      <Box display="flex" justifyContent="space-between">
        <Box>
          <Typography
            variant="h2"
            fontWeight="bold"
            sx={{ color: colors.gray[100] }}
          >
            {title}
          </Typography>
          <Typography variant="h5" sx={{ color: colors.gray[300] }}>
          {subtitle}
        </Typography>
        </Box>
        <Box display="flex" justifyContent="center" mt="10px">
        <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: colors.gray[100] }}
          >
        {icon}
        </Typography>
        </Box>
      </Box>
  
    </Box>
  );
};

export default StatBox;
